import React from 'react'
import logo from '../../../assets/images/KSLOGO.png'
const KeepSmilingLogo = () => {
  return <img src={logo} alt="KeepSmiling logo" className="sb-top-logo" />
}

export default KeepSmilingLogo
